import { Component } from 'react'

export class Search extends Component {


	constructor( props ) {
		super( props )

		this.intervalBeforeSearching = 300

		this.state = {
			'searchText' : props.filters.q
		}

		this.search = this.search.bind( this )
		this.startTimer = this.startTimer.bind( this )
		this.clearTimer = this.clearTimer.bind( this )
		this.setSearchText = this.setSearchText.bind( this )
	}

	componentDidUpdate( prevProps, prevState ) {

		// When the filters are reset, we need to change the text back to blank.
		if ( prevProps.filters.q !== this.props.filters.q && '' === this.props.filters.q ) {
			this.setState({ searchText: '' })
		}
	}

	startTimer() {
		if ( 'undefined' !== typeof this.timer ) {
			clearTimeout( this.timer )
		}

		this.timer = setTimeout( this.search, this.intervalBeforeSearching )
	}

	clearTimer() {
		clearTimeout( this.timer )
	}

	setSearchText( event ) {
		this.setState({ searchText: event.target.value })
	}

	search() {
		this.props.updateFilter( 'q', this.state.searchText )
	}

	render() {
		return (
			<div className="pf-search">
				<label htmlFor="pf-search-box" className="sr-only">Search trips</label>
				
				<input 
					id="pf-search-box"
					className="pf-search__input"
					type="text" 
					name="program-search" 
					onKeyUp={ this.startTimer } 
					onKeyDown={ this.clearTimer } 
					onChange={ this.setSearchText }
					value={ this.state.searchText }
					placeholder="Search trips"
				/>

				<button className="pf-search__submit">
					<span className="sr-only">Search</span>
					<span className="icon-search"></span>
				</button>
			</div>
		)
	}

}